import { Bleed, BlockStack, Box, Card, Divider, InlineStack, RadioButton, Text } from '@shopify/polaris'
import React, { useEffect, useState } from 'react'
import NewAllSales from './NewAllSales'
import NewArchievedOrderTable from './NewArchievedOrderTable'
import { DI, DIProps } from '../../../Core'

const NewAllSalesWithArchieved = (props: DIProps) => {
    const [orderType, setOrderType] = useState('orders')
    console.log(props, "azSXEDRFTGYHUJIK")

    useEffect(() => {
        if (props?.location?.state?.to == 'archive-order') {
            setOrderType("archived")
        }else{
             setOrderType("orders")

        }


    }, [props?.location?.state])



    return (
        <Card padding='0' roundedAbove='sm'>
            <BlockStack gap={"400"}>
                <Box paddingBlockStart="400" paddingInlineStart="400">
                    <InlineStack gap="500" blockAlign='center'>
                        <Text variant="headingSm" as="h6">Order Type:</Text>
                        <InlineStack gap="200">
                            <RadioButton
                                label="Orders"
                                id="fbm"
                                name="fulfilment_type"
                                checked={orderType === 'orders'}
                                onChange={() => setOrderType('orders')}
                            />
                            <RadioButton
                                label="Archived Orders"
                                checked={orderType === 'archived'}
                                id="fba"
                                name="fulfilment_type"
                                onChange={() => setOrderType('archived')}
                            />
                        </InlineStack>
                    </InlineStack>
                </Box>
                <Bleed marginInline="0">
                    <Divider />
                </Bleed>
                {orderType === "orders" ? <NewAllSales /> : <Box  paddingBlockStart={"100"}  padding={{ xs: '200', sm: '200', md: '500', xl: '500' }}><NewArchievedOrderTable /></Box>}
            </BlockStack>
        </Card>
    )
}

export default DI(NewAllSalesWithArchieved)